import type {FC} from 'react';
import {FaArrowRightLong} from 'react-icons/fa6';
import clsx from 'clsx';
import Link from 'next/link';

import type {ButtonProps} from '@/modules/foundation/components/button';
import {Button} from '@/modules/foundation/components/button';

export type CallToActionProps = {
	href: string;
	targetBlank?: boolean;
	text: string;
	variant?: ButtonProps['variant'];
	size?: ButtonProps['size'];
	theme?: 'light' | 'dark';
};

export const CallToAction: FC<CallToActionProps> = ({
	href,
	targetBlank,
	text,
	variant,
	size,
	theme = 'light',
}) => {
	return (
		<Button asChild size={size} variant={variant} data-theme={theme}>
			<Link
				href={href}
				{...(targetBlank && {target: '_blank'})}
				className={clsx(
					'inline-flex',
					'text-center',
					'justify-center',
					'items-center',
					'gap-2',
					'font-bold',
					'transition-colors',
					'duration-200',
					'group',
					'text-black',
					'hover:text-red-600',
				)}
			>
				{text}
				<div className={clsx('transition-all', 'duration-200', 'group-hover:pl-2')}>
					<FaArrowRightLong aria-hidden />
				</div>
			</Link>
		</Button>
	);
};
